import React from 'react';
import LeadGenForm from '@src/components/LeadGenForm';
import PageSection from '@src/components/PageSection';
import type {Languages} from '@src/i18n';
import {graphql} from 'gatsby';
import {LeadGenFormSliceFragment} from '@graphql-types';

export interface LeadGenFormSliceProps {
  languages: Languages[];
  leadGenEndpoint: string;
  webhookAuth: string;
  slice: LeadGenFormSliceFragment;
}

const LeadGenFormSlice: React.FC<LeadGenFormSliceProps> = ({
  languages,
  leadGenEndpoint,
  webhookAuth,
  slice,
}) => {
  const sliceData = {
    heading: slice.primary.header_text,
    submitButtonLabel: slice.primary.cta_button_text,
    text: slice.primary.cta_content.html,
  };

  return (
    <PageSection noBottomPadding={true}>
      <LeadGenForm
        languages={languages}
        leadGenEndpoint={leadGenEndpoint}
        webhookAuth={webhookAuth}
        {...sliceData}
      />
    </PageSection>
  );
};

export default LeadGenFormSlice;

export const query = graphql`
  fragment leadGenFormSlice on PrismicPageDataBodyLeadGenForm {
    id
    slice_type
    primary {
      header_text
      cta_content {
        html
      }
      cta_button_text
    }
  }
`;
